import { BaseService } from "./BaseService";
import { ENV_VARS } from "@/env_vars";

class ChatService extends BaseService {
    constructor(engine) {
        super();
        if (!engine) {
            throw new Error('Missing engine parameter');
        }
        
        this.BASE_URL = ENV_VARS.VUE_APP_REST_BASE_URL || 'https://rest.platform-staging.swascan.com';
        this.ENGINE = engine;
        this.BASE_API = `/api/helperbot/${this.ENGINE}`;
    }

    async sendMessage(payload) {
        
        if (!this.isValidPayload(payload)) {
            throw new Error('Invalid payload structure');
        }

        try {
            const response = await this.post('', payload);
            const responseData = response.data || response;
            return responseData;
        } catch (error) {
            if (error.response && error.response.data) {
                return error.response.data;
            }
            
            throw error;
        }
    }

    isValidMessage(msg) {
        return (
            msg &&
            typeof msg.content === 'string' &&
            typeof msg.tstamp === 'string' &&
            ['user', 'assistant'].includes(msg.role)
        );
    }

    isValidPayload(payload) {
        return (
            payload &&
            payload.context &&
            typeof payload.context.text === 'string' &&
            typeof payload.context.category === 'string' &&
            Array.isArray(payload.history) &&
            payload.history.every(msg => 
                msg.content &&
                msg.tstamp &&
                msg.role &&
                typeof msg.content === 'string' &&
                ['user', 'assistant'].includes(msg.role)
            )
        );
    }
}

export default ChatService;
